<template>
  <div>
    <PageHero
      :hero-image="require('@/assets/HAIR-SALON-SPa.png')"
      :page-title="$t('nav.services')"
    />
    <div class="page-inner content">
      <h1>{{ $t("services.title") }}</h1>
      <RiceDivider :centered="true" />
      <p class="description">{{ $t("services.description") }}</p>

      <div class="promotion-banner">
        <p>{{ $t("services.note") }}</p>
      </div>
      <div class="menu-section">
        <div class="menu-images">
          <div
            class="menu-image-container"
            v-for="img in menuImages"
            :key="img.src"
          >
            <img
              :src="img.src"
              :alt="img.alt"
              class="menu-image"
              @click="openMenuModal(img.src)"
              style="cursor: zoom-in"
            />
          </div>
        </div>
      </div>
      <div v-if="showMenuModal" class="menu-modal" @click.self="closeMenuModal">
        <button class="modal-close" @click="closeMenuModal">&times;</button>
        <div class="modal-zoom-controls">
          <button @click="zoomOut" :disabled="zoomLevel <= 1">-</button>
          <span>{{ Math.round(zoomLevel * 100) }}%</span>
          <button @click="zoomIn">+</button>
        </div>
        <img
          :src="modalMenuImg"
          class="modal-img"
          :style="{ transform: `scale(${zoomLevel})` }"
          @wheel.prevent="onWheelZoom"
        />
      </div>

      <!-- Services Sections -->
      <div class="services-sections">
        <!-- Massage Section -->
        <div id="massage" class="service-section massage-section">
          <div class="service-image">
            <img
              :src="require('@/assets/massage.jpg')"
              alt="Massage Services"
            />
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.massage.title") }}</h2>
              <p class="service-description">
                {{ $t("services.massage.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name"
                  >Massage cổ vai gáy - Neck-Shoulder-Nape</span
                >
                <span class="service-time">30'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Massage Body Thư giãn với Tinh dầu - Massage Body Oil</span
                >
                <span class="service-time">60'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Massage Thư giãn với Tinh dầu - Massage Body Oil</span
                >
                <span class="service-time">90'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Massage Body Thư giãn với Tinh dầu - Massage Body Oil</span
                >
                <span class="service-time">120'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Trị liệu Cổ-Vai-Gáy - Neck-Shoulder-Nape Therapy
                  Massage</span
                >
                <span class="service-time">60'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Massage Body trị liệu với Đá nóng - Body Therapy
                  Massage</span
                >
                <span class="service-time">90'</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Facial Section -->
        <div id="facial" class="service-section facial-section reverse">
          <div class="service-image">
            <img :src="require('@/assets/facial.jpg')" alt="Facial Services" />
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.facial.title") }}</h2>
              <p class="service-description">
                {{ $t("services.facial.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name"
                  >Chăm sóc da cơ bản - Basic Skin Care</span
                >
                <span class="service-time">60'</span>
              </div>
              <div class="service-item">
                <span class="service-name">Thải chỉ da mặt - Skin Detox</span>
                <span class="service-time">75'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Chăm sóc da lão hóa - Aging Skin Treatment</span
                >
                <span class="service-time">75'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Chăm sóc da với tảo - Algae Skin Care</span
                >
                <span class="service-time">90'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Chăm sóc da mụn - Acne Skin Care</span
                >
                <span class="service-time">90'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Chăm da chuyên sâu Collagen - Collagen Intensive Care</span
                >
                <span class="service-time">90'</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Hair Wash Section -->
        <div id="hair-wash" class="service-section hair-section">
          <div class="service-image">
            <img
              :src="require('@/assets/herbal-shampoo.jpg')"
              alt="Hair Wash Services"
            />
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.hairWash.title") }}</h2>
              <p class="service-description">
                {{ $t("services.hairWash.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name"
                  >Gội đầu thư giãn - Nourishing Shampoo</span
                >
                <span class="service-time">45'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Gội đầu dưỡng sinh - Herbal Shampoo</span
                >
                <span class="service-time">60'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Gội thanh tẩy - Scalp Rejuvenation</span
                >
                <span class="service-time">75'</span>
              </div>
              <div class="service-item">
                <span class="service-name">Hấp dầu - Oil Treatment</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Nails Section -->
        <div
          id="nails"
          class="service-section nails-section reverse multi-image"
        >
          <div class="service-image-carousel">
            <div class="carousel-container">
              <img
                v-for="(image, index) in nailImages"
                :key="index"
                :alt="image.alt"
                :class="{ active: currentNailImage === index }"
                :src="image.src"
                class="carousel-image"
              />
            </div>
            <div class="carousel-dots">
              <span
                v-for="(image, index) in nailImages"
                :key="index"
                :class="{ active: currentNailImage === index }"
                class="dot"
                @click="currentNailImage = index"
              ></span>
            </div>
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.nails.title") }}</h2>
              <p class="service-description">
                {{ $t("services.nails.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name">Phá Gel - Break Gel</span>
              </div>
              <div class="service-item">
                <span class="service-name">Cắt da tay - Manicure</span>
              </div>
              <div class="service-item">
                <span class="service-name">Cắt da chân - Pedicure</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Cắt da tay + chân - Manicure & Pedicure</span
                >
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Cắt da tay + sơn Gel/Thạch - Manicure + Gel/Jelly Gel</span
                >
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Cắt da + Thiết kế móng - Manicure/Pedicure + Design</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Eyelashes Section -->
        <div id="eyelashes" class="service-section eyelash-section multi-image">
          <div class="service-image-carousel">
            <div class="carousel-container">
              <img
                v-for="(image, index) in eyelashImages"
                :key="index"
                :alt="image.alt"
                :class="{ active: currentEyelashImage === index }"
                :src="image.src"
                class="carousel-image"
              />
            </div>
            <div class="carousel-dots">
              <span
                v-for="(image, index) in eyelashImages"
                :key="index"
                :class="{ active: currentEyelashImage === index }"
                class="dot"
                @click="currentEyelashImage = index"
              ></span>
            </div>
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.eyelashes.title") }}</h2>
              <p class="service-description">
                {{ $t("services.eyelashes.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name">Mi 2D - Eyelash 2D</span>
              </div>
              <div class="service-item">
                <span class="service-name">Mi 3D-4D - Eyelash 3D-4D</span>
              </div>
              <div class="service-item">
                <span class="service-name">Mi 5D-6D - Eyelash 5D-6D</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Uốn mi phủ Collagen - Collagen Coated Eyelashes</span
                >
              </div>
              <div class="service-item">
                <span class="service-name">Đắm mi - Filled Eyelashes</span>
              </div>
              <div class="service-item">
                <span class="service-name">Mi thiết kế - Design Eyelashes</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Waxing Section -->
        <div id="waxing" class="service-section waxing-section reverse">
          <div class="service-image">
            <img :src="require('@/assets/waxing.webp')" alt="Waxing Services" />
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.waxing.title") }}</h2>
              <p class="service-description">
                {{ $t("services.waxing.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name">Mép Mustache</span>
              </div>
              <div class="service-item">
                <span class="service-name">Chân mày - Eyebrow</span>
              </div>
              <div class="service-item">
                <span class="service-name">Nách - Armpit</span>
              </div>
              <div class="service-item">
                <span class="service-name">Tay - Whole Arm</span>
              </div>
              <div class="service-item">
                <span class="service-name">Chân - Whole Leg</span>
              </div>
              <div class="service-item">
                <span class="service-name">Bikini</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Body Scrub Section -->
        <div id="body-scrub" class="service-section scrub-section">
          <div class="service-image">
            <img
              :src="require('@/assets/scrub.jpg')"
              alt="Body Scrub Services"
            />
          </div>
          <div class="service-content">
            <div class="service-header">
              <h2>{{ $t("services.bodyScrub.title") }}</h2>
              <p class="service-description">
                {{ $t("services.bodyScrub.description") }}
              </p>
            </div>
            <div class="service-list">
              <div class="service-item">
                <span class="service-name">Thanh tẩy - Body Scrub</span>
                <span class="service-time">30'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Mặt nạ ủ dưỡng - Body Care Mask</span
                >
                <span class="service-time">30'</span>
              </div>
              <div class="service-item">
                <span class="service-name"
                  >Thanh tẩy + Mặt nạ ủ dưỡng - Body Scrub & Mask</span
                >
                <span class="service-time">30'</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHero from "@/components/PageHero.vue";

export default {
  components: {
    PageHero,
  },
  data() {
    return {
      menuImages: [
        { src: require("@/assets/menu-front.jpg"), alt: "Menu Front" },
        { src: require("@/assets/menu-back.png"), alt: "Menu Back" },
      ],
      showMenuModal: false,
      modalMenuImg: "",
      zoomLevel: 1,
      currentNailImage: 0,
      currentEyelashImage: 0,
      nailImages: [
        {
          src: "https://reneedayspa.com/wp-content/uploads/2024/03/Classic-Manicure-1024x732.webp",
          alt: "Nail design 1",
        },
        {
          src: "https://images2.thanhnien.vn/Uploaded/yennh/2022_11_19/mtmh3-4395.jpg",
          alt: "Nail design 2",
        },
        {
          src: "https://preview.redd.it/how-to-ask-for-a-specific-cat-eye-pattern-v0-72pf4x3kjsgd1.jpg?width=640&crop=smart&auto=webp&s=8d68545f12767b4ec9c1519fcf7dd663a1674189",
          alt: "Nail design 3",
        },
        {
          src: "https://i.pinimg.com/564x/0f/39/cf/0f39cf40326f5459c4c8501fc6a3a09c.jpg",
          alt: "Nail design 4",
        },
        {
          src: "https://www.nailbliss.com.sg/wp-content/uploads/2021/12/WhatsApp-Image-2022-05-10-at-10.38.17-AM.jpeg",
          alt: "Nail design 5",
        },
      ],
      eyelashImages: [
        {
          src: "https://suckhoedoisong.qltns.mediacdn.vn/324455921873985536/2021/8/30/noi-mi-1-1630292233395450626258.jpg",
          alt: "Eyelash extensions 2",
        },
        {
          src: "https://kamayacosmetics.co.uk/wp-content/uploads/2024/07/KAYEMM-EYELASHES-1.webp",
          alt: "Eyelash extensions 4",
        },
        {
          src: "https://noimihani.com/kcfinder/upload//images/noi-mi-12%283%29.JPG",
          alt: "Eyelash extensions 1",
        },
        {
          src: "https://img.grouponcdn.com/deal/4KpfGvso9WqJxRFirQ2EvMvd6WjZ/4K-3956x2369/v1/sc600x600.webp",
          alt: "Eyelash extensions 3",
        },
        {
          src: "https://ubeauty.vn/wp-content/uploads/2024/07/noi-mi-sole-thai-5.jpg",
          alt: "Eyelash extensions 5",
        },
      ],
    };
  },
  computed: {
    currentMonth() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const date = new Date();
      return months[date.getMonth()];
    },
  },
  mounted() {
    // Auto slide for nail images
    setInterval(() => {
      this.currentNailImage =
        (this.currentNailImage + 1) % this.nailImages.length;
    }, 4000);

    // Auto slide for eyelash images
    setInterval(() => {
      this.currentEyelashImage =
        (this.currentEyelashImage + 1) % this.eyelashImages.length;
    }, 4500);

    // Handle hash scrolling for deep links - với delay để chờ page load xong
    setTimeout(() => {
      this.scrollToSection();
    }, 300);
  },
  methods: {
    scrollToSection() {
      // Wait for DOM to be ready
      this.$nextTick(() => {
        const hash = this.$route.hash;

        if (hash) {
          const element = document.querySelector(hash);

          if (element) {
            const headerOffset = 100;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition =
              elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
      });
    },
    openMenuModal(img) {
      this.modalMenuImg = img;
      this.zoomLevel = 1;
      this.showMenuModal = true;
    },
    closeMenuModal() {
      this.showMenuModal = false;
      this.zoomLevel = 1;
    },
    zoomIn() {
      this.zoomLevel = Math.min(this.zoomLevel + 0.2, 3);
    },
    zoomOut() {
      this.zoomLevel = Math.max(this.zoomLevel - 0.2, 1);
    },
    onWheelZoom(e) {
      if (e.deltaY < 0) this.zoomIn();
      else this.zoomOut();
    },
  },
  watch: {
    $route(to) {
      // Re-scroll when route changes (for navigation from other pages)
      if (to.hash) {
        setTimeout(() => {
          this.scrollToSection();
        }, 300);
      }
    },
  },
};
</script>

<style scoped>
/* Smooth scrolling for the entire page */
html {
  scroll-behavior: smooth;
}

/* Section anchor offset for fixed header */
#massage,
#facial,
#hair-wash,
#nails,
#eyelashes,
#waxing,
#body-scrub {
  scroll-margin-top: 100px;
}

.page-inner {
  padding: 40px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

h1 {
  text-align: center;
  color: var(--primary-color);
  margin-bottom: 20px;
  font-size: 2.5rem;
}

.description {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 40px;
  line-height: 1.6;
  font-size: 1.1rem;
}

.promotion-banner {
  background: linear-gradient(135deg, #f8e3c5 0%, #f4d7a7 100%);
  border: 2px solid var(--primary-color, #8b5a00);
  border-radius: 15px;
  padding: 25px;
  margin: 30px auto 50px;
  text-align: center;
  max-width: 600px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.promotion-banner p {
  font-size: 1.1rem;
  color: var(--primary-color, #8b5a00);
  font-weight: 300;
  margin-bottom: 15px;
}

.menu-images {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 30px;
}

.menu-image-container {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
  max-width: 500px;
}

.menu-image-container:hover {
  transform: translateY(-5px);
}

.menu-image {
  width: 100%;
  height: auto;
  display: block;
}

.menu-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-img {
  max-width: 90vw;
  max-height: 80vh;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  background: #fff;
  transition: transform 0.3s;
}

.modal-close {
  position: absolute;
  top: 24px;
  right: 36px;
  font-size: 2.5rem;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  z-index: 10001;
}

.modal-zoom-controls {
  position: absolute;
  left: 50%;
  bottom: 36px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 18px;
  z-index: 10001;
}

.modal-zoom-controls button {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.3rem;
  cursor: pointer;
  transition: background 0.2s;
}

.modal-zoom-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-zoom-controls span {
  color: #fff;
  font-weight: bold;
  font-size: 1.1rem;
  text-shadow: 0 1px 3px #000;
}

.contact-info p {
  margin: 5px 0;
  font-size: 1rem;
  color: var(--primary-color, #8b5a00);
}

.contact-info strong {
  color: #c49e12;
}

/* Services Sections */
.services-sections {
  margin-top: 40px;
}

.service-section {
  display: flex;
  align-items: center;
  gap: 50px;
  margin-bottom: 50px;
  padding: 30px 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.service-section.reverse {
  flex-direction: row-reverse;
}

.service-image {
  flex: 0 0 45%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service-image img {
  width: 80%;
  height: 500px;
  object-fit: cover;
  border-radius: 45%;
  box-shadow: 8px 8px 0 0 #c49e12;
  transition: none;
}

.service-content {
  flex: 1;
  padding: 15px 0;
  box-sizing: border-box;
}

.service-header h2 {
  font-size: 2.2rem;
  color: #8b6b47;
  margin-bottom: 15px;
  font-weight: 300;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.service-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 25px;
  text-align: justify;
}

.service-list {
  background: rgba(245, 242, 236, 0.4);
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: transparent;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.service-item .service-name {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
}

.service-item .service-name::before {
  content: "+";
  width: auto;
  height: auto;
  color: #c49e12;
  font-size: 1.1rem;
  font-weight: bold;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: -2px;
}

.service-item .service-time {
  font-size: 0.8rem;
  color: #c49e12;
  font-weight: 400;
  letter-spacing: 0.5px;
  background: rgba(196, 158, 18, 0.1);
  padding: 3px 8px;
  border-radius: 15px;
  border: 1px solid rgba(196, 158, 18, 0.2);
  flex-shrink: 0;
}

.service-item::after {
  display: none;
}

.service-item:hover {
  background: rgba(255, 255, 255, 0.3);
}

.service-item span {
  font-size: 0.95rem;
  color: #333;
  font-weight: 300;
}

/* Carousel layout for specific sections */
.service-section.multi-image {
  gap: 60px;
}

.service-image-carousel {
  flex: 0 0 45%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.carousel-container {
  position: relative;
  width: 80%;
  height: 500px;
  border-radius: 45%;
  overflow: hidden;
  box-shadow: 8px 8px 0 0 #c49e12;
  margin: 0 auto;
}

.carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.carousel-image.active {
  opacity: 1;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(196, 158, 18, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #c49e12;
  transform: scale(1.2);
}

.dot:hover {
  background: rgba(196, 158, 18, 0.6);
}

/* Apply section-specific shadows to carousel containers */
.nails-section.multi-image .carousel-container {
  box-shadow: 8px 8px 0 0 #c49e12;
}

.eyelash-section.multi-image .carousel-container {
  box-shadow: 8px 8px 0 0 #764908;
}

.eyelash-section.multi-image .dot {
  background: rgba(118, 73, 8, 0.3);
}

.eyelash-section.multi-image .dot.active {
  background: #764908;
}

.eyelash-section.multi-image .dot:hover {
  background: rgba(118, 73, 8, 0.6);
}

.massage-section .service-image img {
  box-shadow: 8px 8px 0 0 #8b6b47;
}

.facial-section .service-image img {
  box-shadow: 8px 8px 0 0 #a0836b;
}

.hair-section .service-image img {
  box-shadow: 8px 8px 0 0 #956f4a;
}

.nails-section .service-image img {
  box-shadow: 8px 8px 0 0 #c49e12;
}

.eyelash-section .service-image img {
  box-shadow: 8px 8px 0 0 #764908;
}

.waxing-section .service-image img {
  box-shadow: 8px 8px 0 0 #8b5a00;
}

.scrub-section .service-image img {
  box-shadow: 8px 8px 0 0 #a0712a;
}

/* Section specific colors for bullets and content */
.massage-section .service-header h2 {
  color: #8b6b47;
}

.facial-section .service-header h2 {
  color: #a0836b;
}

.hair-section .service-header h2 {
  color: #956f4a;
}

.nails-section .service-header h2 {
  color: #8b6b47;
}

.eyelash-section .service-header h2 {
  color: #764908;
}

.waxing-section .service-header h2 {
  color: #8b5a00;
}

.scrub-section .service-header h2 {
  color: #a0712a;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .service-section {
    flex-direction: column;
    gap: 30px;
    text-align: center;
    padding: 30px 25px;
    margin-bottom: 40px;
  }

  .service-section.reverse {
    flex-direction: column;
  }

  .service-image,
  .service-image-carousel {
    flex: none;
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
  }

  .service-image img {
    width: 80%;
    height: 400px;
  }

  .carousel-container {
    width: 80%;
    height: 400px;
  }

  .service-content {
    max-width: 600px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .service-section {
    gap: 25px;
    margin-bottom: 35px;
    padding: 25px 20px;
  }

  .service-section .service-image,
  .service-section .service-image-carousel {
    max-width: 400px !important;
    width: 100% !important;
  }

  .service-section .service-image img {
    width: 80% !important;
    height: 320px !important;
  }

  .service-section .carousel-container {
    width: 80% !important;
    height: 320px !important;
  }

  .service-header h2 {
    font-size: 1.8rem;
  }

  .service-description {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .service-item {
    padding: 8px 12px;
    gap: 10px;
  }

  .service-item span {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .page-inner {
    padding: 30px 15px;
  }

  .service-section {
    gap: 20px;
    margin-bottom: 30px;
    padding: 20px 0;
  }

  .service-section .service-image,
  .service-section .service-image-carousel {
    max-width: 350px;
    width: 100%;
  }

  .service-section .service-image img {
    width: 80%;
    height: 280px;
  }

  .service-section .carousel-container {
    width: 80%;
    height: 280px;
  }

  .carousel-dots {
    margin-top: 15px;
  }

  .dot {
    width: 10px;
    height: 10px;
  }

  .service-header h2 {
    font-size: 1.5rem;
    margin-bottom: 12px;
  }

  .service-description {
    font-size: 0.95rem;
    margin-bottom: 18px;
    line-height: 1.6;
  }

  .service-item {
    padding: 7px 10px;
    gap: 8px;
    border-radius: 8px;
  }

  .service-item span {
    font-size: 0.85rem;
  }
}
</style>
